import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTopLevelLinks } from '../../../useTopLevelLinks';
import { FooterPrivacyMenuWrapper, StyledLinkV2, NoreferrerLinkV2, styles } from './FooterPrivacyMenu.styles';

export const FooterPrivacyMenu: React.FC = () => {
  const topLevelLinks = useTopLevelLinks();
  return (
    <FooterPrivacyMenuWrapper __css={styles.footerPrivacyMenuWrapper}>
      <Flex alignItems="center" style={{ columnGap: '4px' }}>
        <StyledLinkV2
          id={topLevelLinks.terms.id}
          href={topLevelLinks.terms.href}
          target={topLevelLinks.terms.target}
          onClick={topLevelLinks.terms.onClick}
          typographyVariant="body1"
        >
          {topLevelLinks.terms.label}
        </StyledLinkV2>
        <TextV2 typographyVariant="body1" tagName="span" color="white">
          &
        </TextV2>
        <StyledLinkV2
          id={topLevelLinks.privacy.id}
          href={topLevelLinks.privacy.href}
          target={topLevelLinks.privacy.target}
          onClick={topLevelLinks.privacy.onClick}
          typographyVariant="body1"
        >
          {topLevelLinks.privacy.label}
        </StyledLinkV2>
      </Flex>
      <NoreferrerLinkV2
        id={topLevelLinks.californiaPrivacyNotice.id}
        href={topLevelLinks.californiaPrivacyNotice.href}
        target={topLevelLinks.californiaPrivacyNotice.target}
        onClick={topLevelLinks.californiaPrivacyNotice.onClick}
        noreferrer
        noopener
        typographyVariant="body1"
      >
        {topLevelLinks.californiaPrivacyNotice.label}
      </NoreferrerLinkV2>
      <NoreferrerLinkV2
        id={topLevelLinks.doNotShareInformation.id}
        href={topLevelLinks.doNotShareInformation.href}
        target={topLevelLinks.doNotShareInformation.target}
        onClick={topLevelLinks.doNotShareInformation.onClick}
        noreferrer
        noopener
        typographyVariant="body1"
      >
        {topLevelLinks.doNotShareInformation.label}
      </NoreferrerLinkV2>
    </FooterPrivacyMenuWrapper>
  );
};
